export const DEEP_POPULATE = ['deep']
export const HERO_IMAGE_POPULATE = ['heroImage']
